import React from "react";

import dots1 from '../../../../../assets/appchallengecenter/collection_dots.png';
import checkIcon from '../../../../../assets/appchallengecenter/haken-grau.svg';
import IconClock from '../../../../../assets/icons/ico100_clock.svg';

import ReactMarkdown from "react-markdown";
import { classNames } from "../../../../utils/classNames";
import MarkdownHelper from '../../../../utils/MarkdownHelper';
import { match } from "../../../../utils/match";

const MILES_SYMBOL = '-M-'
const MILES_FORMAT = `xxx ${MILES_SYMBOL}`

/** @typedef {{icon: boolean, text: string, tracker: 'none' | 'bubbles' | 'counter', miles: 'none' | 'task-level' | 'activity-level' }} ChallengeTask */

/** @type {(challengeValues: Record<string, string>) => ChallengeTask[]} */
export const transformChallengeTasks = (challengeValues) => {
    if (!challengeValues) {
        return []
    }
    const range = [...Array(6).keys()]
    return range.map((ri) => {
        const i = ri + 1;
        const icon = challengeValues[`challenge_challenge-${i}-icon`];
        const text = challengeValues[`challenge_challenge-${i}-text`];
        const tracker = challengeValues[`challenge_challenge-${i}-bubbles`];
        const miles = challengeValues[`challenge_challenge-${i}-meilenwert`];

        return {
            text,
            icon: icon === "ja",
            tracker: match(tracker, [
                ['kein Tracker', 'none'],
                ['Bubbles', 'bubbles'],
                ['Counter', 'counter'],
            ], () => 'none'),
            miles: match(miles, [
                ['kein Meilenwert', 'none'],
                ['Tasklevel', 'task-level'],
                ['Activitylevel', 'activity-level'],
            ], () => 'none')
        }
    }).filter(task => Boolean(task.text))
}

const ProgressCircle = (
    /** @type {{ icon: string }} */
    props
) => {
    const dotInner = 5
    const dotStroke = 2
    const dot = dotInner + dotStroke
    const innerSize = 120 + dot * 2
    const center = innerSize / 2

    return (
        <div className="progress-circle-container">
            <img className="icon" src={props.icon} />
            <svg className="progress-circle" viewBox={`0 0 ${innerSize} ${innerSize}`}>
                <circle className="progress-circle__inner" cx={center} cy={center} r="45" fill="#b4b4b4" />
                <circle className="progress-circle__stroke" cx={center} cy={center} r="53" fill="none" strokeWidth="4" stroke="#e8e8e8" />
                <circle className="progress-circle__dot" cx={dot * 2} cy={center} r={dotInner} fill="#e8e8e8" stroke="#ffffff" strokeWidth={dotStroke} />
                <circle className="progress-circle__dot" cx={2 * (center - dot)} cy={center} r={dotInner} fill="#e8e8e8" stroke="#ffffff" strokeWidth={dotStroke} />
                <circle className="progress-circle__dot" cx={center} cy={dot * 2} r={dotInner} fill="#e8e8e8" stroke="#ffffff" strokeWidth={dotStroke} />
                <circle className="progress-circle__dot" cx={center} cy={2 * (center - dot)} r={dotInner} fill="#e8e8e8" stroke="#ffffff" strokeWidth={dotStroke} />
            </svg>
        </div>
    )
}

const ChallengeTask = (
    /** @type {{ task: ChallengeTask }} */
    props
) => {
    return (
        <div className={classNames('challenge-task')}>
            {props.task.icon && <img className="challenge-task__check" src={checkIcon} />}
            <div className="challenge-task__activity">
                <div className={classNames('challenge-task__line')}>
                    <div className="challenge-task__text">{props.task.text}</div>{props.task.miles === 'activity-level' && <div className="challenge-task__miles">{MILES_FORMAT}</div>}
                </div>
                { props.task.tracker !== 'none' &&
                    <div className="challenge-task__task-item">
                        {props.task.tracker === 'bubbles' &&
                            <img className="challenge-task__bubbles" src={dots1} />
                        }
                        {props.task.tracker === 'counter' &&
                            <div className="challenge-task__counter">
                                {'0 / 1000 '}{MILES_SYMBOL}
                            </div>
                        }
                        {props.task.miles === 'task-level' && <div className="challenge-task__miles">{MILES_FORMAT}</div>}
                    </div>
                }
            </div>
        </div>
    )
}

const formatProgress = (progressIndicator) => {
    if (progressIndicator === '% abgeschlossen') {
        return `0${progressIndicator}`
    }
    if (progressIndicator === 'Kein Indikator' || Boolean(progressIndicator) === false) {
        return undefined
    }
    return progressIndicator
}

const Complex = (
    /** @type {{ challengeValues: Record<string, string> }} */
    props
) => {
    const challengeTasks = transformChallengeTasks(props.challengeValues)
    const progress = formatProgress(props.challengeValues["challenge_progress-indicator"])

    return (
        <div className="Collection app-challenge-img-border">
            <div className="detailview-img-headline">
                <ReactMarkdown {...MarkdownHelper.allTypes()}
                    source={MarkdownHelper.parse(props.challengeValues.challenge_announcement)}
                    escapeHtml={false} />
            </div>
            <div className="detailview">
                <div className="detail-card">
                    <div className="detailview-img-meilen-text-container">
                        <div className="detailview-img-meilen-text">
                            {props.challengeValues["challenge_benefit"]}
                        </div>
                        <div className="detailview-img-meilen-text-right">
                            <img src={IconClock} alt="Clock" className="detailview-clock" />
                            <div className="detailview-img-meilen-type">Noch 6 Tage</div>
                        </div>
                    </div>
                    <div className="detail-progress">
                        <ProgressCircle icon={props.challengeValues["challenge_icon-link"]} />
                        <div className="detailview-title--container">
                            <div className="detailview-title-box-container">
                                <div className="detailview-img-title">
                                    {props.challengeValues["challenge_name"]}
                                </div>
                                {progress &&
                                    <div className="detailview-img-abgeschlossen-text">
                                        {progress}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="detailview-tasks-box">
                        {challengeTasks.map((task, index) => <ChallengeTask key={index} task={task} />)}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Complex;


// WEBPACK FOOTER //
// ./src/components/ads/app/appchallengecenter/challengetypes/Complex.js